import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import ExportDatesRange from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportDatesRange'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

const UsedTimeoffFields = ({ form, onEmployeeSelectionChange }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      <ExportDatesRange form={form} />
    </>
  )
}

export default UsedTimeoffFields
